import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import { Modal, Table } from 'antd'
import {withTranslation} from 'react-i18next'

@inject()
@observer
class FormModal extends Component {
  state = {
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const { addModalVisible, handleCancel, record, t} = this.props
    const columns = [
      {
        title: t(`outboundCall.smsStatusDesc`),
        dataIndex: 'smsStatusDesc',
        key: 'smsStatusDesc',
        ellipsis: true,
      },
      {
        title: t(`outboundCall.smsReceiveTime`),
        dataIndex: 'smsReceiveTime',
        key: 'smsReceiveTime',
        ellipsis: true,
      },
      {
        title: t(`outboundCall.smsCount`),
        dataIndex: 'smsCount',
        key: 'smsCount',
        ellipsis: true,
      },
    ]
    return (
      <>
        <Modal
          title={t(`outboundCall.smsRecord`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'35%'}
          centered
          footer={null}
        >
          <Table 
            dataSource={toJS(record.smsList)} 
            pagination={null} 
            rowKey="id" 
            rowClassName={this.getRowClassName}
            columns={columns}
          />
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
